<script>
    const {
        value,
        color = 'blue',
        label = '',
        subLabel = '',
        size = 80,
        ringWidth = 6
    } = $props()

    const strokeWidth = $derived(ringWidth / size * 100)
    const radius = $derived(50 - 0.5 * strokeWidth)
    const circumference = $derived(2 * Math.PI * radius)
    const offset = $derived(circumference * (1 - value))
</script>

<div class="result-ring" style:width="{size}px" style:height="{size}px">
    <svg viewBox="0 0 100 100">
        <circle
            class="background"
            cx={50}
            cy={50}
            r={radius}
            stroke-width={strokeWidth}
            fill="none"
        />

        <circle
            class="progress {color}"
            cx={50}
            cy={50}
            r={radius}
            stroke-width={strokeWidth}
            fill="none"
            stroke-dasharray={circumference}
            stroke-dashoffset={offset}
        />
    </svg>

    <div class="content" style:inset="{ringWidth}px">
        <div class="label">{label}</div>
        <div class="sub-label">{subLabel}</div>
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.result-ring {
  position: relative;
  display: flex;
}
.result-ring svg {
  transform: rotate(-90deg);
}
.result-ring svg .background {
  stroke: rgba(255, 255, 255, 0.5);
}
.result-ring svg .progress {
  stroke-linecap: round;
}
.result-ring svg .progress.blue {
  stroke: hsl(205, 60%, 44%);
}
.result-ring svg .progress.green {
  stroke: #3fd17d;
}
.result-ring svg .progress.orange {
  stroke: #ffa008;
}
.result-ring svg .progress.red {
  stroke: #fc7787;
}
.result-ring .content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.result-ring .content .label {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
.result-ring .content .sub-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}</style>
